// log.js
import { MERGE_ME_DATA } from '../ActionTypes.js';

/**
 * Send log to service
 * @return {import("redux").Middleware}
 */
const log = () => next => action => {
  if (MERGE_ME_DATA === action.type) {
    try {
      if (!action.payload) {
        return next(action);
      }
      const hasTokenField = Object.hasOwn(action.payload, 'token');
      const token = action.payload.token;
      if (hasTokenField && !token) {
        const error = new Error('Update empty access token');
        import('../resource/sentry.js')
          .then(({ getSentry }) => getSentry())
          .then(({ withScope, captureException }) => {
            if (withScope && captureException) {
              withScope(scope => {
                scope.setFingerprint(['emptyAccessToken']);
                scope.setTag('record', 'emptyAccessToken');
                captureException(error);
              });
            }
          });
      }
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
  return next(action);
};

export default log;
